export enum DAG_SYNCS_ENUM {
  PULL_INTEGRATIONS = "PULL_INTEGRATIONS",
  ENRICH_COMPUTE = "ENRICH_COMPUTE",
  PULL_ENRICH_COMPUTE = "PULL_ENRICH_COMPUTE",
  DEPLOY_MERCH = "DEPLOY_EMERCH",
}

export enum SyncStatusEnum {
  SCHEDULED = "SCHEDULED", // Created but not running
  RUNNING = "RUNNING", // In progress
  SUCCEEDED = "SUCCEEDED", // Finished and succeeded
  FAILED = "FAILED", // Finished and failed
}
